import "./EnergyAuditPage2.module.css";
import Header from "@/reusable_sections/Header";
import HomeHero from "./sections/HomeHero";
import EnergyAuditPurpose from "./sections/EnergyAuditPurpose";
import FullWidthImage from "./sections/FullWidthImage";
import ImageSplitLayout from "./sections/ImageSplitLayout";
import EnergyAuditTypes from "./sections/EnergyAuditTypes";
import PourquoiNousFaireConfiance from "./sections/PourquoiNousFaireConfiance";
import NosServices from "./sections/NosServices";
import LesEtapesDeLaudit from "./sections/LesEtapesDeLaudit";
import Temoignages from "./sections/Temoignages";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
import EmptySection from "./sections/EmptySection";
import ServiceContinuity from "./sections/ServiceContinuity";
export default function EnergyAuditPage2() {
  return <div>
      <Header />
      <HomeHero />
      <EnergyAuditPurpose />
      <FullWidthImage />
      <EnergyAuditTypes />
      <ImageSplitLayout />
      <PourquoiNousFaireConfiance />
      <EmptySection />
      <NosServices />
      <LesEtapesDeLaudit />
      <Temoignages />
      <ServiceContinuity />
      <Faq />
      <Footer />
    </div>;
}